import { render, staticRenderFns } from "./GrmMark.vue?vue&type=template&id=ed10a6de&"
import script from "./GrmMark.vue?vue&type=script&lang=js&"
export * from "./GrmMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed10a6de')) {
      api.createRecord('ed10a6de', component.options)
    } else {
      api.reload('ed10a6de', component.options)
    }
    module.hot.accept("./GrmMark.vue?vue&type=template&id=ed10a6de&", function () {
      api.rerender('ed10a6de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/mark/GrmMark.vue"
export default component.exports